import { AccountCircleOutlined } from "@mui/icons-material"
import { Box, Grid, MenuItem, TextField, Typography } from "@mui/material"
import { useNavigate } from "react-router-dom"
import { useAppDispatch, useAppSelector } from "../../../Redux/store"
import { KaziCard } from "../../../Shared Components/Kazi/Cards/KaziCard"
import { toPascalCase } from "../../../Utils/String"
import { setIndustry, setLevel, setJobType, setSkill, setLocation, setWorkSite } from "../Slices/marketplaceSearchSlice"
import { Industry, africanCountries } from "../../../Types/General"
import { useMemo } from "react"
import { TalentSearchFilters } from "./TalentSearchFilters"
import { useTalentFilters } from "../../../Hooks/useTalentFilters"

export const MarketplaceSearch = () => {
    /* ******************** Hooks ******************** */
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const { filterTalents } = useTalentFilters();
    const marketplaceSearchSlice = useAppSelector(state => state.MarketplaceSearch)
    const globalSlice = useAppSelector( state => state.Global);
    /* ******************** Variables ******************** */
    
    const filteredResults = useMemo(() => {
        let results = marketplaceSearchSlice.Result;
        // if (marketplaceSearchSlice.Industry) {
        //     const filter = marketplaceSearchSlice.Industry
        //     results = results.filter( r => r?.work_preferences?.industry == filter || r?.title == filter)
        // }
        // if (marketplaceSearchSlice.Jobtype) {
        //     const filter = marketplaceSearchSlice.Jobtype
        //     results = results.filter( r => r?.work_preferences?.type == filter || r?.type == filter)
        // }
        // if (marketplaceSearchSlice.Level) {
        //     const filter = marketplaceSearchSlice.Level
        //     results = results.filter( r => r?.resume?.expertise?.expertise_level == filter || r?.level == filter)
        // }
        // if (marketplaceSearchSlice.Worksite) {
        //     const filter = marketplaceSearchSlice.Worksite
        //     results = results.filter( r => r?.work_preferences?.site == filter || r?.work_site == filter)
        // }
        //We don't collect location info on jobs, need to revisit this one
        // if (marketplaceSearchSlice.Location) {
        //     const filter = marketplaceSearchSlice.Location
        //     results.filter( r => r?.resume?.expertise?.expertise_level == filter || r?.level == filter)
        // }
        return results
    }, [marketplaceSearchSlice])
    /* ******************** Functions ******************** */
    /* ******************** Effects ******************** */
    /* ******************** JSX ******************** */

    return(
        <>
            {/* <TalentSearchFilters /> */}
            <Grid 
                display={"grid"} 
                gridTemplateRows={'Repeat(3, auto)'}
                paddingLeft={6}
                paddingTop={5}
                rowGap={4}
            >
                <Typography variant='lora-headline-small'>
                    Search for <Typography variant='lora-headline-small' fontWeight={"bold"}>"{`${marketplaceSearchSlice.Search}`}"</Typography>
                </Typography>
                <Grid 
                    container 
                    gap={4}
                    marginTop={2}
                >
                    {
                        filteredResults.map((result, idx) => (
                            <Grid item xs="auto" key={idx}>
                                {
                                    globalSlice.userType === 'talent'?                              
                                    <KaziCard 
                                        title={result.title}
                                        subtitle={result.client_locator}
                                        body={'*insert location*'}
                                        body2={`${result.type} · *insert work-site*`}
                                        label={`${result.applicants.length} applicants`}
                                        icon={<AccountCircleOutlined />}
                                        showDivider={true}
                                        cardAction={() => navigate(`/marketplace/posting/${result.locator}`)}
                                    /> :     
                                    <KaziCard 
                                        title={result.title}
                                        subtitle={`${toPascalCase(result.first_name)} ${result.last_name.charAt(0).toUpperCase()}.`}
                                        body={result.resume?.languages?.map((lang: any) => lang.name).join(', ') ?? ' '}
                                        tags={result.tags}
                                        icon={<AccountCircleOutlined />}
                                        cardAction={() => navigate(`/profile/talent/${result.locator}`)}
                                    />
                                }  
                            </Grid>
                        ))
                    }
                </Grid>
            </Grid>
        </>
    )
}